<template>
  <Modal v-model="distributionModeModal" :title="distributionModeTitle"
    width="700" :transfer="false" :mask-closable="false" @on-visible-change="distributionModeModalChange">
    <Tabs type="card" v-model="tabsName" @on-click="changeTab" :animated="false">
      <TabPane v-for="(item,index) in tabList" :key="index" :label="item.title" :name="item.key">
        <Table
          highlight-row
          border
          max-height="550"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData">
        </Table>
      </TabPane>
    </Tabs>
    <template #footer>
      <Button @click="distributionModeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="tableData.length<=0" @click="distributionModeBtn">{{ $t('key1000111') }}</Button>
    </template>

  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {amountHandel, getAllMatchingLogisticsData} from '@/utils/common';

export default {
  name: "distributionModeModal",
  mixins: [Mixin],
  props: {
    distributorEnableCarrierTalg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      distributionModeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000407'),
      distributionModeModal: false,
      tabList: [],
      tabsName: 'ymsEnableCarrier',
      tableColumns: [
        {
          width: 60,
          align: "left",
          key: 'checkBox',
          _isChecked: false,
          resizable: true,
          renderHeader: (h, params) => {
          },
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  'on-change': (e) => {
                    v.tableData.forEach((items) => {
                      v.$set(items, 'checkBox', false);
                    });
                    v.tableData[params.index].checkBox = e;
                  }
                }
              })
            ]);
          }
        },
        {
          key: 'carrierShippingMethodName',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000408'),
          align: 'left',
          minWidth: 250,
        },
        {
          key: 'code',
          align: 'left',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000409'),
          minWidth: 100,
        },
        {
          key: 'logisticsTimeliness',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency < maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            } else {
              text = maxEfficiency + ' - ' + minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000411');
            }
            return h('div', text);
          }
        }
      ],
      tableData: [],
      domesticData: [],
      abroadData: [],
      freightTest: 0,
      receivingAddress: {},
      editData: {}
    };
  },
  methods: {
    // 初始化数据
    initDistributionModeData(type, obj, receivingAddress) {
      let titleObj = {
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000412'),
        select: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000407')
      };
      this.editData = obj;
      this.receivingAddress = receivingAddress || {};
      this.distributionModeTitle = titleObj[type];
      this.getDistributionModeData(obj);
    },
    // 获取配送方式的数据
    getDistributionModeData(obj) {
      let query = {
        warehouseIds: [obj.ymsWarehouseId],
      }
      let values = this.$store.state.platformOrderDetails;
      if (values?.orderTag === 'TIKTOK_CBT') {
        query.performanceType = 2;
      }
      getAllMatchingLogisticsData(query).then((newData) => {
        newData.map((item) => {
          if (item.ymsWarehouseId === obj.ymsWarehouseId) {
            if (this.distributorEnableCarrierTalg) {
              this.tabList = item.logisticsData.filter((ele) => {
                return ele.key !== 'distributorEnableCarrier' && ele.list.length > 0;
              });
            } else {
              this.tabList = item.logisticsData.filter((ele) => {
                return ele.list.length > 0;
              });
            }
            if (this.tabList.length > 0) {
              this.tabsName = this.tabList[0].key;
            }
            this.changeTab(this.tabsName);
          }
        });
        this.distributionModeModal = true;
      });
    },
    // 弹窗的确定按钮
    distributionModeBtn() {
      if (this.tableData.length > 0) {
        let obj = {};
        this.tableData.map((item) => {
          if (item.checkBox) {
            obj = item;
          }
        });
        if (Object.keys(obj).length > 0) {
          this.handerFreight(obj);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000413'));
          return false;
        }
      }
    },
    // 计算当前选中的物流渠道的运费
    handerFreight(obj) {
      let v = this;
      if (v.tabsName === 'ymsEnableCarrier') {
        v.axios.get(api.get_ymsLogisService + obj.ymsLogisServiceId, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              data.name = obj.name;
              data.code = obj.code;
              data['ymsWarehouseId'] = v.editData.ymsWarehouseId;
              data['carrierMerchantType'] = obj.carrierMerchantType;
              v.handerData(data);
            }
          }
        });
      } else {
        let carrierMerchantType = {
          ymsEnableCarrier: 3,
          distributorEnableCarrier: 2,
          supplierEnableCarrier: 1
        };
        let query = {
          carrierMerchantType: carrierMerchantType[v.tabsName], // 1 供应商  2 分销商  3 运营
          merchantId: obj.merchantId,
          shippingMethodId: obj.shippingMethodId
        };
        v.axios.post(api.post_ymsCarrierShippingMethod_getShippingMethodPriceModel, query,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              data.name = obj.carrierShippingMethodName;
              data.code = obj.code;
              data['ymsWarehouseId'] = v.editData.ymsWarehouseId;
              data['carrierMerchantType'] = obj.carrierMerchantType;
              v.handerData(data);
            }
          }
        });
      }
    },
    // 处理配送的范围的类型
    handerData(data) {
      let v = this;
      if (data) {
        let arriveableType = data.arriveableType;
        let formula = null;
        data['countryCode'] = null;
        let talg = false;
        // 全球可达(运费相同)
        if (arriveableType === 1) {
          data['countryCode'] = true;
          v.distributionModeModal = false;
          v.$emit('updateDeliveryMethodData', data);
        }
        // 全球可达(运费不同)
        else if (arriveableType === 2) {
          data['countryCode'] = true;
          v.distributionModeModal = false;
          v.$emit('updateDeliveryMethodData', data);
        }
        // 全球可达(运费不同) 、非全球可达
        else {
          let countryCode = Object.keys(v.receivingAddress).length > 0 ? v.receivingAddress.countryCode : null;
          let carrierShippingMethodPriceModelZones = null;
          if (v.tabsName === 'ymsEnableCarrier') {
            carrierShippingMethodPriceModelZones = data.ymsLogisServicePriceModel.carrierShippingMethodPriceModelZones;
          } else {
            carrierShippingMethodPriceModelZones = data.carrierShippingMethodPriceModel.carrierShippingMethodPriceModelZones;
          }
          if (carrierShippingMethodPriceModelZones && carrierShippingMethodPriceModelZones.length > 0) {
            for (let i = 0; i < carrierShippingMethodPriceModelZones.length; i++) {
              let item = carrierShippingMethodPriceModelZones[i];
              let countryList = item.carrierShippingMethodPriceModelZoneCountryList;
              if (countryList) {
                for (let j = 0; j < countryList.length; j++) {
                  let ele = countryList[j];
                  if (ele.twoCode === countryCode) {
                    formula = item.formula;
                    if (formula) {
                      talg = true;
                      data['countryCode'] = ele.twoCode;
                      v.distributionModeModal = false;
                      v.$emit('updateDeliveryMethodData', data);
                      break;
                    }
                  }
                }
              }
            }
          }
          if (!data['countryCode'] && !talg) {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000414'));
            return false;
          }
        }
      }
    },
    // 切换tab栏
    changeTab(name) {
      let v = this;
      v.tableData = [];
      v.tabList.map((item) => {
        if (item.key === name) {
          v.tableData = item.list;
        }
      });
      if (Object.keys(v.editData).length > 0) {
        let ymsLogisServiceId = v.editData.ymsLogisServiceId;
        if (v.tableData.length > 0) {
          v.tableData.map((talg) => {
            if (talg.ymsLogisServiceId === ymsLogisServiceId) {
              v.$set(talg, 'checkBox', true);
            }
          });
        }
      }
    },
    // 监听弹窗
    distributionModeModalChange(value) {
      if (!value) {
        this.editData = {};
        this.tabsName = 'ymsEnableCarrier';
        this.tableData = [];
        this.tabList = [];
      }
    }
  }
};
</script>

<style scoped>

</style>
